export default {
  title: 'Warehousing',

  labels: {
    checkExitReceiptByRow: 'Pull out confirmation by row'
  },

  notifications: {
    edit: {
      success: 'Edit inventory setting successfully done.',
      error: 'Edit inventory setting has error.'
    },
    parseError: {
      defaultStoreroomForPersonalSale: 'Selected default warehouse is not valid!'
    }
  }
}
